import request from '@/utils/request';
import { AxiosPromise } from 'axios';

/**
 * 虚拟键盘列表
 * @param params
 * @returns
 */
export const getVirtualKeyboardList = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/marketing/virtual_buttons/list',
    method: 'get',
    params,
  });

/**
 * 后台-虚拟键盘删除
 * @param params
 * @returns
 */
export const delVirtualKeyboard = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/marketing/virtual_buttons/delete',
    method: 'delete',
    params,
  });

/**
 * 后台-虚拟键盘移动页面
 * @param params
 * @returns
 */
export const moveVirtualKeyboard = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/marketing/virtual_buttons/move_page',
    method: 'put',
    data,
  });
/**
 * 后台--虚拟键盘更新通过/拒绝
 * @param params
 * @returns
 */
export const updateVirtualKeyboard = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/marketing/virtual_buttons/update_decision',
    method: 'put',
    data,
  });

/**
 * 后台--虚拟键盘排序
 * @param params
 * @returns
 */
export const sortByKey = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/marketing/virtual_buttons/sort',
    method: 'put',
    data,
  });
/**
 *后台-虚拟键盘发布
 * @param params
 * @returns
 */
export const releaseVirtualKeyboard = (endpoint: number): Promise<any> =>
  request({
    url: '/api/v1/omc/marketing/virtual_buttons/release/' + endpoint,
    method: 'put',
  });
/**
 *后台-虚拟键盘审核
 * @param params
 * @returns
 */
export const auditVirtualKeyboard = (data: any): Promise<any> =>
  request({
    url: '/api/v1/omc/marketing/virtual_buttons/audit',
    method: 'put',
    data,
  });
